import { collection, CollectionReference, Firestore } from "firebase/firestore";

export default function col<T extends object>(
  db: Firestore,
  ...pathSegments: string[]
) {
  return collection(db, pathSegments.join("/")) as CollectionReference<T>;
}
